<div *ngIf="enrichedAttributes$ | async as enrichedAttributes" class="property-detail-shortcodes flex flex-col gap-5">
  <div class="property-detailshortcodes-guidebook" *ngFor="let enrichedAttribute of enrichedAttributes">
    <strong>{{ enrichedAttribute.key | humanize }}</strong>

    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      <p class="text__small nomargin flex-1">
        <ng-container
          *ngFor="
            let word of enrichedAttribute.meta.description.split('%' + enrichedAttribute.key + '%');
            let last = last
          ">
          {{ word }}
          <ng-container *ngIf="!last">
            <span class="shortcode">%{{ enrichedAttribute.key }}%</span>
          </ng-container>
        </ng-container>
      </p>

      <mat-form-field class="input__mini nopadding w-[320px] flex-1">
        <input
          matInput
          type="text"
          [placeholder]="enrichedAttribute.meta.example"
          [(ngModel)]="enrichedAttribute.value"
          (change)="updatePropertyEnrichedAttribute(enrichedAttribute.key, enrichedAttribute.value)" />
      </mat-form-field>
    </div>
  </div>

  <div class="flex items-center justify-end gap-3">
    <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
  </div>
</div>
